import React, { useCallback } from "react";
import Link from "next/link";
import PropTypes from "prop-types";
import styles from "./footer.module.scss";
import DeferredIcon from "../../../components/deferred-icon/DeferredIcon";
import { ConditionalWrapper } from "@/lib/helpers";
import { usePath } from "@/contexts/path/path";
import { trackRNPLFooterClick } from "@/lib/tracking/trackRNPLEvents";

const LinksCol = ({ links }) => {
  const { listingType, category, previousPath, updateContext } = usePath();

  const handleRNPLClick = useCallback(() => {
    trackRNPLFooterClick({
      listingType,
      category: category?.ga_property_category,
      source: previousPath || decodeURI(document.referrer),
    });
  }, [listingType, category, previousPath]);

  return (
    <div className={styles.linkCol}>
      {links.map(
        ({
          iconProps,
          link,
          pathProps,
          label,
          textColor,
          disableClientSideNav,
          onClick,
        }) => (
          <ConditionalWrapper
            key={label}
            condition={disableClientSideNav}
            wrapper={(children) =>
              link ? (
                <a href={link} onClick={onClick} className={styles.link}>
                  {children}
                </a>
              ) : (
                <button onClick={onClick} className={styles.link}>
                  {children}
                </button>
              )
            }
            elseWrapper={(children) => {
              return (
                <Link
                  onClick={(event) => {
                    // eslint-disable-next-line no-unused-expressions
                    onClick && onClick();
                    if (pathProps) {
                      updateContext({
                        ...pathProps,
                        skipRouting: true,
                      });
                    }
                    if (link.match(/rent-now-pay-later/gi)) {
                      handleRNPLClick();
                    }
                  }}
                  className={styles.link}
                  href={link}
                  passHref
                >
                  {children}
                </Link>
              );
            }}
          >
            {!!iconProps && (
              <div className={styles.iconContainer}>
                <DeferredIcon alt="إنتقل الى" {...iconProps} />
              </div>
            )}
            <div
              className={styles.label}
              style={{ color: textColor || undefined }}
            >
              {label}
            </div>
          </ConditionalWrapper>
        ),
      )}
    </div>
  );
};

LinksCol.propTypes = {
  links: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      iconProps: PropTypes.shape({
        type: PropTypes.string,
        width: PropTypes.number,
        height: PropTypes.number,
      }),
    }),
  ),
};

LinksCol.defaultProps = {
  links: [],
};

export default LinksCol;
